<div class="fullscreen-modal">

  <div class="actions-buttons-container">
    <button class="close-modal-button" (click)="closeModal()">❌</button>

    <button class="share-button" (click)="sharePhoto()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#efcb08"
          d="M17 22q-1.25 0-2.125-.875T14 19q0-.15.075-.7L7.05 14.2q-.4.375-.925.588T5 15q-1.25 0-2.125-.875T2 12t.875-2.125T5 9q.6 0 1.125.213t.925.587l7.025-4.1q-.05-.175-.062-.337T14 5q0-1.25.875-2.125T17 2t2.125.875T20 5t-.875 2.125T17 8q-.6 0-1.125-.213T14.95 7.2l-7.025 4.1q.05.175.063.338T8 12t-.012.363t-.063.337l7.025 4.1q.4-.375.925-.587T17 16q1.25 0 2.125.875T20 19t-.875 2.125T17 22" />
      </svg>
    </button>

    <button class="download-button" (click)="downloadPhotoByThirdParty()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" stroke="#f15428" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path fill="#f15428" fill-opacity="0" stroke-dasharray="20" stroke-dashoffset="20"
            d="M12 4h2v6h2.5l-4.5 4.5M12 4h-2v6h-2.5l4.5 4.5">
            <animate attributeName="d" begin="0.5s" dur="1.5s" repeatCount="indefinite"
              values="M12 4h2v6h2.5l-4.5 4.5M12 4h-2v6h-2.5l4.5 4.5;M12 4h2v3h2.5l-4.5 4.5M12 4h-2v3h-2.5l4.5 4.5;M12 4h2v6h2.5l-4.5 4.5M12 4h-2v6h-2.5l4.5 4.5" />
            <animate fill="freeze" attributeName="fill-opacity" begin="0.7s" dur="0.5s" values="0;1" />
            <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.4s" values="20;0" />
          </path>
          <path stroke-dasharray="14" stroke-dashoffset="14" d="M6 19h12">
            <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="14;0" />
          </path>
        </g>
      </svg>
    </button>
  </div>


  <div class="modal-header">
    <div class="photo-by">
      <h2>Photo by {{ displayName }}</h2>
    </div>
    <div class="timer-container">
      <span class="timer">⏳ Expires in: {{ timeRemaining }}</span>
    </div>

  </div>

  <!-- <div class="modal-content"> -->
  <div class="loading-container" *ngIf="isImageLoading">
    <div class="spinner"></div>
    <p>Loading image...</p>
  </div>

  <img [src]="photoUrl" alt="Photo" class="full-photo" [ngClass]="{'hidden': isImageLoading}" (load)="onImageLoad()"
    (error)="onImageError()">
  <!-- <img src="assets/images/pinch.png" class="pinch-hint fade-out" alt="Pinch to zoom"> -->
  <!-- </div> -->

  <div class="actions-container">
    <button *ngIf="!isPublisher" class="like-button" [class.active]="likeStatus === 'liked'" (click)="likePhoto()"
      [disabled]="hasInteractedOnce || likeStatus === 'disliked'">
      ❤️ Like to add 1 hour<span class="badge">{{ likeCount }}</span>
    </button>
    <button *ngIf="!isPublisher" class="dislike-button" [class.active]="likeStatus === 'disliked'"
      (click)="dislikePhoto()" [disabled]="hasInteractedOnce || likeStatus === 'liked'">
      👎 Dislike to remove 1 hour <span class="badge">{{ dislikeCount }}</span>
    </button>
    <button *ngIf="isPublisher" class="delete-button" (click)="deletePhoto()">
      🗑 Delete
    </button>
  </div>
</div>